import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateIBeaconForm } from "../../forms"

export const CreateIBeacon: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreateIBeaconForm />
		</VStack>
	)
}
